export const stripBom = (value = "") => String(value).replace(/^\ufeff/, "");

export const findPhoneColumnKey = (headers = []) => {
    const normalizedHeaders = headers.map((header) => stripBom(header.trim()));
    return normalizedHeaders.find((header) => header.toLowerCase() === "phone number") || "Phone number";
};

export const getPhoneFromRow = (row, phoneColumnKey) =>
    row?.[phoneColumnKey] ?? row?.["Phone number"] ?? row?.["Phone Number"] ?? "";

export const normalizeImportRows = (rows, phoneColumnKey) =>
    rows.map((row) => ({
        ...row,
        "Phone number": getPhoneFromRow(row, phoneColumnKey),
    }));
